(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-information"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Thumbnail click
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.getElementById('main-product-image');
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImage.style.transform = 'scale(0.98)';
      mainImage.src = thumb.dataset.full;
      setTimeout(() => mainImage.style.transform = 'scale(1)', 50);
    });
  });

  // Variant chip click
  document.querySelectorAll('.variant-chips').forEach(group => {
    group.querySelectorAll('.variant-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        group.querySelectorAll('.variant-chip').forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
      });
    });
  });

  // Color dot click
  document.querySelectorAll('.color-dots').forEach(group => {
    group.querySelectorAll('.color-dot').forEach(dot => {
      dot.addEventListener('click', () => {
        group.querySelectorAll('.color-dot').forEach(d => d.classList.remove('active'));
        dot.classList.add('active');
      });
    });
  });

  // Quantity buttons
  const qtyNumber = document.querySelector('.qty-number');
  document.querySelector('.qty-btn.plus').addEventListener('click', () => {
    qtyNumber.textContent = parseInt(qtyNumber.textContent) + 1;
  });
  document.querySelector('.qty-btn.minus').addEventListener('click', () => {
    qtyNumber.textContent = Math.max(1, parseInt(qtyNumber.textContent) - 1);
  });

  // Tabs
  const tabs = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const target = tab.dataset.tab;
      tabContents.forEach(c => c.classList.remove('active'));
      document.getElementById(target).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
